document.addEventListener('DOMContentLoaded', () => {

    if (!document.body.classList.contains('product')) {
        return;
    }

    const header = document.getElementById('main-header');
    const logo = document.querySelector('[data-header-logo]');
    const nav = document.querySelector('[data-header-nav]');
    const actions = document.querySelector('[data-header-actions]');
    const menuDesktop = document.querySelector('.menu-desktop');

    if (!header || !logo || !nav || !actions || !menuDesktop) {
        return;
    }

    let isHovering = false;
    let scrollTimeout = null;
    let lastScrollTop = 0;
    let isCollapsed = false;
    let isActive = false;
    let expandTriggerSection = null;


    function getNaturalHeight(element) {
        const hadCollapsed = element.classList.contains('pdp-nav-collapsed') || element.classList.contains('pdp-actions-collapsed');
        const originalMaxHeight = element.style.maxHeight;
        const originalOpacity = element.style.opacity;
        const originalOverflow = element.style.overflow;
        const originalPadding = element.style.paddingBlock;

        element.classList.remove('pdp-nav-collapsed', 'pdp-nav-expanded', 'pdp-actions-collapsed', 'pdp-actions-expanded');
        element.style.setProperty('max-height', 'none');
        element.style.setProperty('opacity', '1');
        element.style.setProperty('overflow', 'visible');
        element.style.removeProperty('padding-block');

        void element.offsetHeight;

        const height = element.scrollHeight;

        element.style.maxHeight = originalMaxHeight;
        element.style.opacity = originalOpacity;
        element.style.overflow = originalOverflow;
        element.style.paddingBlock = originalPadding;

        if (hadCollapsed) {
            if (element === nav) {
                element.classList.add('pdp-nav-collapsed');
            } else {
                element.classList.add('pdp-actions-collapsed');
            }
        }

        return height;
    }

    const navNaturalHeight = getNaturalHeight(nav);
    const actionsNaturalHeight = getNaturalHeight(actions);

    function collapseHeader() {
        if (isHovering || isCollapsed) return;

        isCollapsed = true;

        nav.style.setProperty('--nav-height', `${navNaturalHeight}px`);
        actions.style.setProperty('--actions-height', `${actionsNaturalHeight}px`);

        nav.classList.add('pdp-nav-collapsed');
        nav.classList.remove('pdp-nav-expanded');

        actions.classList.add('pdp-actions-collapsed');
        actions.classList.remove('pdp-actions-expanded');
    }

    function expandHeader() {
        if (!isCollapsed) return;

        isCollapsed = false;

        nav.style.setProperty('--nav-height', `${navNaturalHeight}px`);
        actions.style.setProperty('--actions-height', `${actionsNaturalHeight}px`);

        nav.classList.add('pdp-nav-expanded');
        nav.classList.remove('pdp-nav-collapsed');

        actions.classList.add('pdp-actions-expanded');
        actions.classList.remove('pdp-actions-collapsed');
    }

    function handleScroll() {
        if (scrollTimeout) {
            clearTimeout(scrollTimeout);
        }

        scrollTimeout = setTimeout(() => {
            const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

            let shouldExpandAutomatically = false;
            let triggerTop = null;

            if (expandTriggerSection) {
                const triggerRect = expandTriggerSection.getBoundingClientRect();
                triggerTop = triggerRect.top;
                if (triggerRect.top <= 0) {
                    shouldExpandAutomatically = true;
                }
            }

            if (shouldExpandAutomatically && !isHovering && isCollapsed) {
                expandHeader();
            } else if (!shouldExpandAutomatically && !isHovering && lastScrollTop > currentScrollTop && !isCollapsed) {
                collapseHeader();
            }

            lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
        }, 10);
    }

    function handleHeaderMouseEnter() {
        isHovering = true;
        if (isCollapsed) {
            expandHeader();
        }
    }

    function handleHeaderMouseLeave() {
        isHovering = false;

        const shouldExpandAutomatically = expandTriggerSection && expandTriggerSection.getBoundingClientRect().top <= 0;

        if (!shouldExpandAutomatically && !isCollapsed) {
            collapseHeader();
        }
    }

    function activate() {
        if (isActive) return;
        isActive = true;
        isCollapsed = false;

        const allSections = document.querySelectorAll('main .shopify-section');
        const isMokoTracker = document.body.classList.contains('moko-tracker');
        const hasProductSection = !!document.getElementById('product-wrapper');
        expandTriggerSection = allSections[isMokoTracker && hasProductSection ? 4 : 2] || null;

        nav.style.setProperty('--nav-height', `${navNaturalHeight}px`);
        actions.style.setProperty('--actions-height', `${actionsNaturalHeight}px`);

        nav.classList.add('no-transition');
        actions.classList.add('no-transition');

        requestAnimationFrame(() => {
            nav.classList.add('pdp-nav-collapsed');
            actions.classList.add('pdp-actions-collapsed');
            isCollapsed = true;

            setTimeout(() => {
                nav.classList.remove('no-transition');
                actions.classList.remove('no-transition');
            }, 50);
        });

        menuDesktop.addEventListener('mouseenter', handleHeaderMouseEnter);
        menuDesktop.addEventListener('mouseleave', handleHeaderMouseLeave);
        window.addEventListener('scroll', handleScroll, { passive: true });
    }

    function deactivate() {
        if (!isActive) return;
        isActive = false;
        isCollapsed = false;
        isHovering = false;

        nav.classList.remove('pdp-nav-collapsed', 'pdp-nav-expanded', 'no-transition');
        actions.classList.remove('pdp-actions-collapsed', 'pdp-actions-expanded', 'no-transition');
        nav.style.removeProperty('--nav-height');
        actions.style.removeProperty('--actions-height');

        menuDesktop.removeEventListener('mouseenter', handleHeaderMouseEnter);
        menuDesktop.removeEventListener('mouseleave', handleHeaderMouseLeave);
        window.removeEventListener('scroll', handleScroll);
    }

    if (window.innerWidth >= 1024) {
        activate();
    }

    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            if (window.innerWidth >= 1024) {
                activate();
            } else {
                deactivate();
            }
        }, 250);
    });
});
